import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Union } from 'src/app/models/Union';
import { Voter } from 'src/app/models/Voter';
import { ElectionColleges } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-union-table',
  templateUrl: 'union-table.component.html',
  styleUrls: ['./union-table.component.less', '../../../../shared/common.less'],
})

export class UnionTableComponent implements OnInit {
  @Input() unions: Array<Union> = [];
  @Input() colleges: Array<ElectionColleges> = [];
  @Input() selectedRound: boolean = true;
  @Input() voters: Array<Voter> = [];
  @Input() selectedVoters: Array<Voter> = [];
  @Input() areUnionsValidated: boolean = false;
  @Output() selectedVotersChange = new EventEmitter<Array<Voter>>();
  @Input() filteredVoters: Array<Voter> = [];
  isVotersValid = false;

  private readonly denominationToCollegeNumber: { [key: string]: number } = {
    'Collège Unique': 1,
    '1er Collège: ouvriers, employés': 1,
    '2ème Collège: techniciens, agents de maîtrise, ingénieurs et cadres': 2,
    '3ème Collège: ingénieurs et cadres': 3,
    'Autre Collège': 4
  };

  constructor() { }

  removeAtIndex(index: number) {
    this.unions.splice(index, 1);
  }

  selectionChangedEvent(newSelection: Array<Voter>) {
    this.selectedVoters = newSelection;
    this.selectedVotersChange.emit(newSelection);
  }

  resetVoters() {
    this.voters = [];
    this.filteredVoters = [];
  }

  getFormattedColleges(union: Union): string {
    if (!union.associatedColleges || union.associatedColleges.length === 0) {
      return '';
    }
    return union.associatedColleges.map(idx => {
      const college = this.colleges[idx];
      const denomination = college?.collegeType?.[0] || '';
      return this.denominationToCollegeNumber[denomination] ?? (idx + 1);
    }).join(', ');
  }

  ngOnInit(): void {
  }
}
